export const initialState = {
    projectId: "",
    name: "",
    status: "",
    clients: [],
    orgStructure: [],
    type: "project",
    engagements: [],
    owners: [
    ],
    users: [
      {
        userId: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
      }
    ],
    engagementCount: 0,
    createdDate: null,
    createdBy: "",
    modifiedDate: null,
    modifiedBy: "",
};


// Refer below structure.

/*
[{
	"projectId":"eb553723-1a63-4cd2-8455-a963b812e409",
	"name":"Project Name",
	"status":"Draft",
	"clients":[
	   {"clientCode":"1", "name": "Client 1"},
	   {"clientCode":"2", "name": "Client 2"}
	],
	"users":[
		{"userId": "2342678", "initials":"TV"},
		{"userId": "2342679","initials":"SR"},
		{"userId": "Pavan.R.Ban@cocacola.com","initials":"PB"}
	],
	"engagementCount":2,
	"type":"project",
	"orgStructure":[
		{
			"id":1,
			"parentId":null,
			"entityName":"Global",
			"level":1,
			"accessGroups":[],
			"engagements":[123465,154342],
		},
		{
			"id":2,
			"parentId":1,
			"entityName": "North America",
			"level":2,
			"accessGroups":[1,2],
			"engagements":[225465,354642]		
		},
		{
			"id":3,
			"parentId":1,
			"entityName": "Asia",
			"level":2,
			"accessGroups":[1,2],
			"engagements":[423365,554321]
		},
		{
			"id":4,
			"parentId":2,
			"entityName":"United States",
			"level":3,
			"accessGroups":[],
			"engagements":[623465,754342],
		},
		{
			"id":5,
			"parentId":2,
			"entityName":"Canada",
			"level":3,
			"accessGroups":[],
			"engagements":[828565,906342],
		},
		{
			"id":6,
			"parentId":3,
			"entityName":"India",
			"level":3,
			"accessGroups":[],
			"engagements":[8885576,8448885],
		},
		{
			"id":7,
			"parentId":3,
			"entityName":"China",
			"level":3,
			"accessGroups":[],
			"engagements":[1112232,2557786],
		}
	],
	"createdDate":"04/1/2021 12:28 PM",
	"createdBy":"2342678",
	"modifiedDate":null,
	"modifiedBy":null
},
{
	"projectId":"eb553723-1a63-4cd2-8455-a963b812e409", 
	"accessGroupId":1, 
	"groupName":"Owners Group",
	"views":[],
	"users":[
		{
			"userId":"2342678", 
			"firstName":"Tanmay", 
			"lastName":"Vartak",
			"userType":"Member",
			"projectRoles":[{"name":"owner"}]
		}
	],
	"domains":[],
	"isBuiltin":true,
	"type":"accessGroup"
},
{
	"projectId":"eb553723-1a63-4cd2-8455-a963b812e409", 
	"accessGroupId":1, 
	"groupName":"My Access Group 1",
	"views":[{"name":"milestones"},{"name":"clientcolaboration"}],
	"users":[
		{
			"userId":"2342678", 
			"firstName":"Tanmay", 
			"lastName":"Vartak",
			"userType":"Member",			
			"projectRoles":[{"name":"admin"},{"name":"owner"}]
		},
		{
			"userId":"Pavan.R.Ban@cocacola.com", 
			"firstName":"Pavan", 
			"lastName":"Ban",
			"userType":"Guest",			
			"projectRoles":[{"name":"user"}]
		}
	],
	"domains":[{"name":"@cocacola-us.com"},{"name":"@google.com"}],
	"isBuiltin":false,
	"type":"accessGroup"
}
]
*/